/* @flow */

import * as React from 'react';
import styled from '@emotion/styled';

type Props = {
  component?: string,
  description: string,
  icon: mixed
};

const defaultProps = {
  component: 'div'
};

const Item = styled(({ component: Component, ...props }) => <Component {...props} />)(
  ({ theme }) => ({
    alignItems: 'center',
    display: 'flex',
    flex: '0 0 50%',
    margin: 0,
    padding: '0.5em 1em',
    [theme.mediaQuery.tabletLandscapeAndUp]: {
      flexBasis: '33.33%'
    }
  })
);

const LegendIcon = styled.span({
  alignItems: 'center',
  display: 'flex',
  fontSize: '1.5em',
  width: '1.5em',
  paddingRight: '0.5em'
});

const LegendDescription = styled.span({
  fontWeight: 'normal',
  textTransform: 'uppercase'
});

function LegendItem({ component, description, icon }: Props) {
  return (
    <Item component={component}>
      <LegendIcon>{icon}</LegendIcon>
      <LegendDescription>{description}</LegendDescription>
    </Item>
  );
}

LegendItem.defaultProps = defaultProps;

export default LegendItem;
